// extracted by mini-css-extract-plugin
export default {"button":"Nl-z","reviewSort":"Ol-z"};